export default {
    data () {
        return {
            actionTypes: [
                "No Action",
                "Quote",
                "Proceed As Quoted",
                "Observe & Comment",
                "Attend On Call Out",
                "Completed"
            ],
        };
    },
    methods: {
        issuePreview(issue, htmlFormat) {
            let issueLocation = issue.location !== '' ? ` @${issue.location} ` : '';
            let issueDescription = issue.description !== '' ? ` - ${issue.description} ` : '';

            return !htmlFormat
                ? `${issue.item}${issueLocation}${issueDescription}`
                : `<span>${issue.item}</span>
                   <span class="text-light-blue">${issueLocation}</span>
                   <span class="text-light-gray">${issueDescription}</span>`;
        }
    }
}
